import React, { useEffect, useState } from 'react';
import { BookingFlow } from './BookingFlow';
import { Playground } from './Playground';

function App() {
    // Simple manual routing since react-router-dom is not available
    const [path, setPath] = useState(window.location.pathname);

    useEffect(() => {
        const handlePopState = () => {
            setPath(window.location.pathname);
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    // DEV-ONLY GUARD
    // Show Playground ONLY if path is /dev/playground AND we are in development (or if we want to allow it in prod for specific route? request says "Accessible only in development")
    // Request: "If NODE_ENV === 'development' (or equivalent), allow '/dev/playground'. Otherwise ... redirect"

    const isDev = process.env.NODE_ENV === 'development';
    const isPlaygroundRoute = path === '/dev/playground';

    if (isPlaygroundRoute) {
        if (isDev) {
            return <Playground />;
        } else {
            // In production, redirect /dev/playground to /booking or /
            // Since we can't do a real server redirect, we just render the BookingFlow 
            // and perhaps replace the URL to avoid confusion?
            // window.history.replaceState(null, '', '/');
            // For now, just render BookingFlow as fallback.
            return <BookingFlow />;
        }
    }

    // Default Route / Booking Route
    return <BookingFlow />;
}

export default App;
